/* global PNotify */
import { isEmpty } from 'lodash';
export const TYPES = {
    NOTICE: 'notice',
    INFO: 'info',
    ERROR: 'error',
    SUCCESS: 'success',
};
const NOTIFICATION_DELAY = 5000;
const TOP_EDGE = 55;
const LEFT_EDGE = 25;
export const NOTIFICATION_STACK = {
    dir1: 'down',
    dir2: 'left',
    firstpos1: TOP_EDGE,
    firstpos2: LEFT_EDGE,
};
function createNotification(title, text, type, t) {
    new PNotify({
        addclass: isEmpty(text) ? 'no-text' : '',
        title,
        text: Array.isArray(text) ? text.join('\n') : text,
        type,
        delay: NOTIFICATION_DELAY,
        push: 'bottom',
        stack: NOTIFICATION_STACK,
        buttons: {
            labels: { close: t('Close'), stick: t('Stick'), unstick: t('Unstick') },
        },
    });
}
function systemNonReactWarning(title, text) {
    new PNotify({
        title,
        text: Array.isArray(text) ? text.join('\n') : text,
        type: TYPES.INFO,
        hide: false,
        delay: 0,
        push: 'bottom',
        stack: NOTIFICATION_STACK,
        buttons: {
            labels: { close: 'Close', stick: 'Stick', unstick: 'Unstick' },
        },
    });
}
export default {
    error: (title, text, t) => createNotification(title, text, TYPES.ERROR, t),
    notice: (title, text, t) => createNotification(title, text, TYPES.NOTICE, t),
    success: (title, text, t) => createNotification(title, text, TYPES.SUCCESS, t),
    info: (title, text, t) => createNotification(title, text, TYPES.INFO, t),
    systemNonReactWarning,
};
